module.exports = {
  schema: {
    // name: '門市資料',
    type: 'Object',
    contents: {
      ragicId: {
        type: 'Number',
        ragicId: '_ragicId',
        name: 'RagicId',
        disable: true,
      },
      key: {
        type: 'String',
        name: '門市代碼',
        ragicId: '1000070',
        unique: true,
      },
      name: {
        type: 'String',
        ragicId: '1000001',
        name: '名稱',
      },
      organize: {
        type: 'String',
        ragicId: '1000476',
        name: '組織類別',
      },
      fullName: {
        type: 'String',
        ragicId: '1000135',
        name: '門市公司名',
      },
      storeName: {
        type: 'String',
        ragicId: '1000002',
        name: '門市店名',
      },
      owner: {
        type: 'String',
        ragicId: '1000009',
        name: '負責人',
      },
      profitEnterpriseKey: {
        type: 'String',
        ragicId: '1000189',
        name: '營業登記號碼',
      },
      CID: {
        type: 'String',
        ragicId: '1000005',
        name: '統一編號',
      },
      pharmKey: {
        type: 'String',
        ragicId: '1000190',
        name: '藥商許可證號碼',
      },
      phone: {
        type: 'String',
        ragicId: '1000006',
        name: '門市電話',
      },
      phone2: {
        type: 'String',
        ragicId: '1000134',
        name: '備用電話',
      },
      fax: {
        type: 'String',
        ragicId: '1000007',
        name: '門市傳真',
      },
      address: {
        type: 'String',
        ragicId: '1000008',
        name: '門市地址',
      },
      storageMA: {
        type: 'String',
        ragicId: '1000472',
        name: '庫存管理',
        options: ['執行', '不執行'],
        input: 'select',
      },
      manager: {
        type: 'String',
        ragicId: '1000184',
        name: '店長',
      },
      isOpen: {
        type: 'String',
        ragicId: '1000493',
        name: '是否營業',
        options: ['是', '否'],
        input: 'select',
      },
      openDate: {
        type: 'Date',
        ragicId: '1000011',
        name: '開幕日期',
      },
      type: {
        type: 'String',
        ragicId: '1000004',
        name: '門市類別',
      },
      closeDate: {
        type: 'Date',
        ragicId: '1000012',
        name: '閉店日期',
      },
      level: {
        type: 'String',
        ragicId: '1000003',
        name: '門市級別',
      },
      note: {
        type: 'String',
        ragicId: '1000017',
        name: '備註說明',
      },
      ragicStoreNodeId: {
        type: 'Number',
        name: 'Ragic門市資料Id',
        noclone: true,
      },
      ragicCenterNodeId: {
        type: 'Number',
        name: 'Ragic管理中心資料Id',
        noclone: true,
      },
      syncCenterAt: {
        type: 'Date',
        name: '上次同步管理中心時間',
      },
      syncStoreAt: {
        type: 'Date',
        name: '上次同步門市時間',
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 100 },
        { key: 'name', width: 130 },
        { key: 'owner', width: 100 },
        { key: 'CID', width: 100 },
        { key: 'phone', width: 100 },
        { key: 'isOpen', width: 100 },
        { key: 'ragicCenterNodeId', width: 100 },
        { key: 'ragicStoreNodeId', width: 100 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '門市資料',
          rows: [
            [{ key: 'key' }],
            [{ key: 'name' }],
            [{ key: 'fullName' }],
            [{ key: 'storeName' }],
            [{ key: 'owner' }],
            [{ key: 'profitEnterpriseKey' }],
            [{ key: 'CID' }],
            [{ key: 'pharmKey' }],
            [{ key: 'phone' }],
            [{ key: 'phone2' }],
            [{ key: 'fax' }],
            [{ key: 'address' }],
            [{ key: 'storageMA' }],
            [{ key: 'manager' }],
            [{ key: 'isOpen' }],
            [{ key: 'openDate' }],
            [{ key: 'type' }],
            [{ key: 'closeDate' }],
            [{ key: 'level' }],
            [{ key: 'note' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/stores.js